<template>
  <div
    class="modal show"
    v-bind:class="{ show: visible }"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            @click="close"
          >
            <slot name="close">&times;</slot>
          </button>
             <slot name="header">
               
             </slot>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
        <div class="modal-footer">          
          <slot name="footer"></slot>
          <slot name="confirm"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Modal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.visible = false
    },
    open() {
      this.visible = true
    }
},
};
</script>

<style scoped>
.modal-header{  
  background: rgba(135, 206, 235,0.3);
}
.modal-body {
  height:200px;
  overflow:auto;
  background: rgba(191, 239, 255,0.2);
}
.modal-footer{
  background: rgba(135, 206, 235,0.3);
}

</style>


// WEBPACK FOOTER //
// src/components/ui-elements/Modal.vue